import { Avatar, Checkbox, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import styled from 'styled-components/macro';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

interface MultiAutocompleteWithSelectorProps {
  dataSelector: any; // selector
  // loadingSelector: any; // selector
  loadDataErrorSelector: any; // selector
  label?: string;
  handleSetOnEdit?: Function;
  onChange?: Function;
  value?: any[];
  disabled?: boolean;
}

const MultiAutocompleteWithSelector: React.FC<MultiAutocompleteWithSelectorProps> = ({
  value,
  dataSelector,
  loadDataErrorSelector,
  disabled: disabledFromProps,
  onChange,
  label,
  handleSetOnEdit,
}) => {
  const [values, setValues] = React.useState<any[]>(value as any[]);
  const options: {
    value: any;
    label: string;
    imageUrl?: string;
    hoverText?: string;
  }[] = useSelector(dataSelector);

  const valueOptionMap = useMemo(
    () =>
      options
        ? options.reduce(
            (acc, option) => ({ ...acc, [option.value]: option }),
            {},
          )
        : {},
    [options],
  );

  const loadDataError = useSelector(loadDataErrorSelector);

  const valuesForAc = useMemo(
    () =>
      values
        .map((value) => valueOptionMap && valueOptionMap[value])
        .filter((val) => val !== undefined),
    [values, valueOptionMap],
  );

  const disabled = useMemo(
    () =>
      (loadDataError !== null && loadDataError !== '') ||
      disabledFromProps,
    [loadDataError, disabledFromProps],
  );

  // const [onFocus, setOnFocus] = useState(false);
  // const handleSetOnFocus = (val: boolean) => {
  //   setOnFocus(val);
  // };

  const handleChange = (
    event: React.ChangeEvent<{}>,
    eValue: any,
  ) => {
    const value = eValue.map((item) => item.value);
    setValues(value);
    if (onChange) {
      onChange({
        target: {
          value,
        },
      });
    }
  };

  /**
   * for reset (same as in MultiTextField)
   */
  useEffect(() => {
    if (value && Array.isArray(value)) setValues(value);
  }, [value]);

  return (
    <SAutocomplete
      multiple
      value={valuesForAc}
      //   id="checkboxes-tags-demo" // need this?
      options={options}
      disableCloseOnSelect
      getOptionLabel={(option) => (option as any).label}
      renderOption={(option: any, { selected }) => (
        <React.Fragment>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
          />
          {option?.imageUrl !== undefined && (
            <SAvatar src={option?.imageUrl} />
          )}
          {(option as any).label}
        </React.Fragment>
      )}
      onOpen={(event) => handleSetOnEdit && handleSetOnEdit(true)}
      onClose={(event) => handleSetOnEdit && handleSetOnEdit(false)}
      //   onFocus={() => handleSetOnFocus(true)}
      //   onBlur={() => handleSetOnFocus(false)}
      onChange={(e, value) => handleChange(e, value)}
      renderInput={(params) => (
        <STextField {...params} variant="outlined" label={label} />
      )}
      ChipProps={{
        size: 'small',
        style: {
          maxWidth: 200,
        },
      }}
      disabled={disabled}
    />
  );
};

export default MultiAutocompleteWithSelector;
const STextField: any = styled(TextField)`
  & .MuiOutlinedInput-input {
    padding: 15.5px 14px;
    font-size: ${(props) => props.theme.typography.fontSize.small};
  }
  & .MuiOutlinedInput-root {
    &:hover fieldset {
      border-color: ${(props) => props.theme.palette.primary.main};
    }
  }
  & .MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(2px, 2px) scale(0.75);
    margin-left: 5px;
  }
  & legend {
    width: 0;
  }
`;
const SAutocomplete = styled(Autocomplete)`
  &.MuiAutocomplete-root:not(.Mui-focused) {
    flex: 1;
  }
  & .MuiInputLabel-outlined:not(.Mui-focused) {
    z-index: 2;
  }
  & .MuiInputLabel-outlined.Mui-focused {
    z-index: 2;
  }
  & .MuiInputBase-root:not(.Mui-focused) {
    height: 3rem;
    overflow: hidden;
    /* flex-wrap: nowrap; */
    display: block;
    white-space: nowrap;
    & .MuiInputBase-input {
      height: 0;
      padding: 0;
    }
    & .MuiAutocomplete-endAdornment {
      background: white;
      height: 3rem;
      top: 0;
      right: 0;
      display: flex;
      align-items: center;
    }
  }
  & .MuiInputBase-root.Mui-focused {
  }

  & .MuiInputBase-root {
    position: absolute;
    z-index: 1;
    background: white;
  }

  & .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] {
    padding: 0;
    padding-top: 10px;
    padding-bottom: 4px;
  }
`;
// MuiAutocomplete-root MultiAutocompleteWithSelector__SAutocomplete-sc-1tr7d5c-1 jtwbFD MuiAutocomplete-hasClearIcon MuiAutocomplete-hasPopupIcon

const SAvatar = styled(Avatar)`
  &.MuiAvatar-root {
    width: 25px;
    height: 25px;
    margin-right: 0.5rem;
  }
`;
